import { useIntl } from 'react-intl'
import { Link } from 'solito/link'

import Box from 'app/components/base/Box'
import Image from 'app/components/base/Image'
import Paper from 'app/components/base/Paper'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface SimilarItemCardProps {
  image: string
  link: string
  title: string
  price: number
  currency: string
}

const SimilarItemCard: RFC<SimilarItemCardProps> = ({
  image,
  link,
  title,
  price,
  currency
}) => {
  const { formatNumber } = useIntl()

  const currentCurrency = formatNumber(price, { style: 'currency', currency })

  return (
    <Paper
      sx={{
        minWidth: 240,
        width: 240,
        height: 65,
        p: 0,
        borderRadius: '16px',
        ...(!IS_NATIVE_APP && {
          boxShadow:
            '0px 0px 2px 0px rgba(199, 207, 216, 0.7), 0px 12px 24px -4px rgba(145, 158, 171, 0.15)'
        })
      }}
    >
      <Link href={link} prefetch={false} aria-label="similar-card">
        <Stack
          direction="row"
          spacing={1.25}
          sx={{ alignItems: 'center', pr: 3 }}
        >
          <Box
            sx={{
              position: 'relative',
              width: 65,
              minWidth: 65,
              height: 65
            }}
          >
            <Image
              src={image}
              alt={title}
              fill
              sizes={'200px'}
              style={{ borderTopLeftRadius: 16, borderBottomLeftRadius: 16 }}
            />
          </Box>

          <Stack direction="column" sx={{ ...(IS_NATIVE_APP && { flex: 1 }) }}>
            <Text variant="body2" lineClamp={1} sx={{ fontWeight: 500 }}>
              {title}
            </Text>

            <Text variant="subtitle1">{currentCurrency}</Text>
          </Stack>
        </Stack>
      </Link>
    </Paper>
  )
}

export default SimilarItemCard
